import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { ProtectedHome } from "./components/layout/ProtectedHome";
import { AppShell } from "./components/layout/AppShell";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const RegisterPage = lazy(() => import("./pages/RegisterPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const ConfirmEmailPage = lazy(() => import("./pages/ConfirmEmailPage"));
const AuthConfirmPage = lazy(() => import("./pages/AuthConfirmPage"));
const OnboardingPage = lazy(() => import("./pages/OnboardingPage"));
const ItemsPage = lazy(() => import("./pages/items/ItemsPage"));
const AcceptInvitationPage = lazy(() => import("./pages/AcceptInvitationPage"));
const PublicListPage = lazy(() => import("./pages/public/PublicListPage"));

const App: React.FC = () => {
  return (
    <AppShell>
      <Suspense fallback={<div className="ob-loading">Loading…</div>}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          <Route path="/auth/confirm" element={<AuthConfirmPage />} />
          <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
          <Route path="/share/:token" element={<PublicListPage />} />
          <Route
            path="/*"
            element={
              <ProtectedHome
                onboarding={<OnboardingPage />}
                home={<ItemsPage />}
              />
            }
          />
        </Routes>
      </Suspense>
    </AppShell>
  );
};

export default App;

